// Animation observer for elements with 'animate' class
function initAnimateObserver() {
    const animateElements = document.querySelectorAll('.animate');

    if (animateElements.length === 0) {
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    // Element is entering viewport
                    entry.target.classList.add('is-animated');
                    entry.target.classList.remove('animate-out-of-view');

                    // Check if element has countup class
                    if (entry.target.classList.contains('animate-countup')) {
                        onEnterAnimation(entry.target);
                    }
                } else {
                    // Element is leaving viewport
                    entry.target.classList.add('animate-out-of-view');
                }
            });
        },
        {
            threshold: 0.1, // Trigger when 10% of element is visible
            rootMargin: '0px 0px -10% 0px' // Trigger slightly before element enters viewport
        }
    );

    // Observe all elements with 'animate' class
    animateElements.forEach((element) => {
        observer.observe(element);
    });
}

// Initialize animate observer when DOM is loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimateObserver);
} else {
    initAnimateObserver();
}

// Export functions for external use
window.initAnimateObserver = initAnimateObserver;